import axios from 'axios';
// config
import { SERVER_ADDRESS } from '../config';

// ----------------------------------------------------------------------
console.log(`the baseurl is ${SERVER_ADDRESS}`);
const axiosInstance = axios.create({ baseURL: SERVER_ADDRESS });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
